<template>

    <svg version="1.2"
         xmlns="http://www.w3.org/2000/svg"
         xmlns:xlink="http://www.w3.org/1999/xlink"
         overflow="visible"
         preserveAspectRatio="none"
         viewBox="0 0 20 20"
         width="10"
         height="10">
        <g>
            <defs> </defs>
            <rect display="none" fill="#FFA400" width="20" height="20" style="fill: rgb(252, 13, 0);" vector-effect="non-scaling-stroke"/> <rect id="_x3C_Slice_x3E__109_" display="none" fill="none" width="20" height="20" style="fill: rgb(252, 13, 0);" vector-effect="non-scaling-stroke"/> <polygon fill-rule="evenodd" clip-rule="evenodd" points="20,3 17,0 10,7 3,0 0,3 7,10 0,17 3,20 10,13 17,20 20,17 13,10 " style="fill: rgb(252, 13, 0);" vector-effect="non-scaling-stroke"/>
        </g>
    </svg>
</template>

<script>
    export default {
        name: "RedCrossSVG"
    }
</script>

<style scoped>

</style>